import { Reveal, RevealLine } from "../lib/motion";
import { MANIFESTO, ABOUT_PHOTO } from "../data";

export const About = () => (
  <section id="chi-sono" data-testid="about-section" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-6 sm:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal className="overline mb-6">Chi sono</Reveal>
          <h2 className="font-serif text-4xl sm:text-5xl leading-tight text-[var(--ink)] mb-8">
            <RevealLine>Trasformo la</RevealLine>
            <RevealLine delay={0.08} className="italic text-[var(--petrol)]">complessità</RevealLine>
            <RevealLine delay={0.16}>in decisioni.</RevealLine>
          </h2>
          <Reveal delay={0.2} className="relative aspect-[3/2] overflow-hidden mt-6">
            <img src={ABOUT_PHOTO} alt="Gabriella Ritondo — sede della holding" className="w-full h-full object-cover object-center scale-100 hover:scale-105 transition-transform duration-700" />
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-lg text-[var(--ink-soft)] leading-relaxed first-letter:font-serif first-letter:text-6xl first-letter:text-[var(--petrol)] first-letter:mr-3 first-letter:float-left first-letter:leading-[0.8]">
              Accompagno CEO, imprenditori e Consigli di Amministrazione nelle scelte che contano: governo
              dell'intelligenza artificiale, gestione del rischio d'impresa e trasformazione digitale. La mia
              esperienza come Deputy CIO e advisor mi permette di tradurre la tecnologia in strategia e la
              strategia in risultati concreti e misurabili.
            </p>
          </Reveal>

          <div className="mt-14 grid sm:grid-cols-2 gap-px bg-[var(--line)] border border-[var(--line)]">
            {MANIFESTO.map((m, i) => (
              <Reveal key={m.n} delay={i * 0.08} className="bg-white p-8 hover:bg-[var(--paper-2)] transition-[background-color] duration-500">
                <div className="font-serif text-3xl text-[var(--accent)] mb-3">{m.n}</div>
                <h3 className="text-xl font-semibold mb-2 text-[var(--ink)]">{m.title}</h3>
                <p className="text-sm text-[var(--ink-soft)] leading-relaxed">{m.body}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
